export default __webpack_public_path__ + "static/media/09.0d399723.jpg";